/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getJobCard = /* GraphQL */ `
  query GetJobCard($id: ID!) {
    getJobCard(id: $id) {
      id
      companyName
      jobNo
      impExp
      mode
      airlineName
      masterBLNo
      masterAWBNo
      houseBLNo
      houseAWBNo
      AWBDate
      AWBId
      shipperName
      shipperAddress01
      shipperAddress02
      shipperAddress03
      shipperAddress04
      consigneeName
      consigneeAddress01
      consigneeAddress02
      consigneeAddress03
      consigneeAddress04
      notifyName
      notifyAddress01
      notifyAddress02
      notifyAddress03
      notifyAddress04
      deliveryAgentName
      deliveryAgentAddress01
      deliveryAgentAddress02
      deliveryAgentAddress03
      deliveryAgentAddress04
      placeOfReceipt
      portOfLoading
      EtdAtPortOfLoading
      portOfDischarge
      finalPlaceOfDelivery
      EtaAtPortOfDischarge
      vesselVoy
      bookingAgentName
      bookingAgentAddress
      marksAndNumbers
      containerNo
      lineSealNo
      customSealNo
      typeOfContainer
      description
      netWeight
      grossWeight
      measurement
      chaName
      checkListNo
      checkListDate
      shippingBillNo
      shippingBillDate
      coLoader
      stuffingDate
      noOfPackages
      pallet
      palletNo
      certificate
      otherCertificateName
      insurance
      transportation
      specialInstructions
      editable
      RequestedDate
      accountId
      ownerEmail
      status
      type
      closeAt
      closeBy
      cancelAt
      cancelBy
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listJobCards = /* GraphQL */ `
  query ListJobCards(
    $filter: ModeljobCardFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listJobCards(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        companyName
        jobNo
        impExp
        mode
        airlineName
        masterBLNo
        masterAWBNo
        houseBLNo
        houseAWBNo
        AWBDate
        AWBId
        shipperName
        shipperAddress01
        shipperAddress02
        shipperAddress03
        shipperAddress04
        consigneeName
        consigneeAddress01
        consigneeAddress02
        consigneeAddress03
        consigneeAddress04
        notifyName
        notifyAddress01
        notifyAddress02
        notifyAddress03
        notifyAddress04
        deliveryAgentName
        deliveryAgentAddress01
        deliveryAgentAddress02
        deliveryAgentAddress03
        deliveryAgentAddress04
        placeOfReceipt
        portOfLoading
        EtdAtPortOfLoading
        portOfDischarge
        finalPlaceOfDelivery
        EtaAtPortOfDischarge
        vesselVoy
        bookingAgentName
        bookingAgentAddress
        marksAndNumbers
        containerNo
        lineSealNo
        customSealNo
        typeOfContainer
        description
        netWeight
        grossWeight
        measurement
        chaName
        checkListNo
        checkListDate
        shippingBillNo
        shippingBillDate
        coLoader
        stuffingDate
        noOfPackages
        pallet
        palletNo
        certificate
        otherCertificateName
        insurance
        transportation
        specialInstructions
        editable
        RequestedDate
        accountId
        ownerEmail
        status
        type
        closeAt
        closeBy
        cancelAt
        cancelBy
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const getNextJobNo = /* GraphQL */ `
  query GetNextJobNo($id: ID!) {
    getNextJobNo(id: $id) {
      id
      nextTVTJobNo
      nextTLIJobNo
      nextEGLJobNo
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listNextJobNos = /* GraphQL */ `
  query ListNextJobNos(
    $filter: ModelnextJobNoFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listNextJobNos(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        nextTVTJobNo
        nextTLIJobNo
        nextEGLJobNo
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const getBookingAgent = /* GraphQL */ `
  query GetBookingAgent($id: ID!) {
    getBookingAgent(id: $id) {
      id
      name
      address
      type
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listBookingAgents = /* GraphQL */ `
  query ListBookingAgents(
    $filter: ModelbookingAgentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBookingAgents(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        address
        type
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const getShipper = /* GraphQL */ `
  query GetShipper($id: ID!) {
    getShipper(id: $id) {
      id
      name
      address01
      address02
      address03
      address04
      createdAt
      type
      updatedAt
      owner
    }
  }
`;
export const listShippers = /* GraphQL */ `
  query ListShippers(
    $filter: ModelshipperFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listShippers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        address01
        address02
        address03
        address04
        createdAt
        type
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const getConsignee = /* GraphQL */ `
  query GetConsignee($id: ID!) {
    getConsignee(id: $id) {
      id
      name
      address01
      address02
      address03
      address04
      createdAt
      type
      updatedAt
      owner
    }
  }
`;
export const listConsignees = /* GraphQL */ `
  query ListConsignees(
    $filter: ModelconsigneeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listConsignees(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        address01
        address02
        address03
        address04
        createdAt
        type
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const getNotify = /* GraphQL */ `
  query GetNotify($id: ID!) {
    getNotify(id: $id) {
      id
      name
      address01
      address02
      address03
      address04
      createdAt
      type
      updatedAt
      owner
    }
  }
`;
export const listNotifies = /* GraphQL */ `
  query ListNotifies(
    $filter: ModelnotifyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listNotifies(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        address01
        address02
        address03
        address04
        createdAt
        type
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const getDeliveryAgent = /* GraphQL */ `
  query GetDeliveryAgent($id: ID!) {
    getDeliveryAgent(id: $id) {
      id
      name
      address01
      address02
      address03
      address04
      createdAt
      type
      updatedAt
      owner
    }
  }
`;
export const listDeliveryAgents = /* GraphQL */ `
  query ListDeliveryAgents(
    $filter: ModeldeliveryAgentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDeliveryAgents(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        address01
        address02
        address03
        address04
        createdAt
        type
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const getPort = /* GraphQL */ `
  query GetPort($id: ID!) {
    getPort(id: $id) {
      id
      name
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listPorts = /* GraphQL */ `
  query ListPorts(
    $filter: ModelportFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPorts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const getDestinationPort = /* GraphQL */ `
  query GetDestinationPort($id: ID!) {
    getDestinationPort(id: $id) {
      id
      name
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listDestinationPorts = /* GraphQL */ `
  query ListDestinationPorts(
    $filter: ModeldestinationPortFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDestinationPorts(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const getAirportCode = /* GraphQL */ `
  query GetAirportCode($id: ID!, $createdAt: AWSDateTime!) {
    getAirportCode(id: $id, createdAt: $createdAt) {
      id
      code
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listAirportCodes = /* GraphQL */ `
  query ListAirportCodes(
    $id: ID
    $createdAt: ModelStringKeyConditionInput
    $filter: ModelairportCodeFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listAirportCodes(
      id: $id
      createdAt: $createdAt
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        code
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const getCarrierCode = /* GraphQL */ `
  query GetCarrierCode($id: ID!, $createdAt: AWSDateTime!) {
    getCarrierCode(id: $id, createdAt: $createdAt) {
      id
      code
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listCarrierCodes = /* GraphQL */ `
  query ListCarrierCodes(
    $id: ID
    $createdAt: ModelStringKeyConditionInput
    $filter: ModelcarrierCodeFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listCarrierCodes(
      id: $id
      createdAt: $createdAt
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        code
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const getDestinationAirport = /* GraphQL */ `
  query GetDestinationAirport($id: ID!, $createdAt: AWSDateTime!) {
    getDestinationAirport(id: $id, createdAt: $createdAt) {
      id
      name
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listDestinationAirports = /* GraphQL */ `
  query ListDestinationAirports(
    $id: ID
    $createdAt: ModelStringKeyConditionInput
    $filter: ModeldestinationAirportFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listDestinationAirports(
      id: $id
      createdAt: $createdAt
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        name
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const getAirline = /* GraphQL */ `
  query GetAirline($id: ID!) {
    getAirline(id: $id) {
      id
      name
      logoUrl
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listAirlines = /* GraphQL */ `
  query ListAirlines(
    $filter: ModelairlineFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAirlines(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        logoUrl
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const getAwb = /* GraphQL */ `
  query GetAwb($id: ID!) {
    getAwb(id: $id) {
      id
      url
      awbNumberOne
      awbNumberTwo
      awbNumberThree
      awbNumberFour
      typeOfAWB
      airline
      carrierAgentName
      carrierAgentCity
      iataCode
      accountNo
      airportOfDept
      toOne
      byFirstCarrier
      toTwo
      byOne
      toThree
      byTwo
      airportOfDestination
      accountingInformation
      currency
      chgs
      option
      declaredValueForChange
      declaredValueForCustoms
      amountOfInsurance
      handlingInformation
      chargeableWeight
      rate
      total
      description
      extraDescription
      weightCharge
      valuationCharge
      tax
      dueAgent
      dueCarrier
      totalPrepaid
      totalCollect
      currencyConversionRate
      ccChargesInDestCurrency
      chargesAtDestination
      totalCollectCharges
      otherCharges
      signOfShipper
      executedOn
      place
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listAwbs = /* GraphQL */ `
  query ListAwbs(
    $filter: ModelawbFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAwbs(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        url
        awbNumberOne
        awbNumberTwo
        awbNumberThree
        awbNumberFour
        typeOfAWB
        airline
        carrierAgentName
        carrierAgentCity
        iataCode
        accountNo
        airportOfDept
        toOne
        byFirstCarrier
        toTwo
        byOne
        toThree
        byTwo
        airportOfDestination
        accountingInformation
        currency
        chgs
        option
        declaredValueForChange
        declaredValueForCustoms
        amountOfInsurance
        handlingInformation
        chargeableWeight
        rate
        total
        description
        extraDescription
        weightCharge
        valuationCharge
        tax
        dueAgent
        dueCarrier
        totalPrepaid
        totalCollect
        currencyConversionRate
        ccChargesInDestCurrency
        chargesAtDestination
        totalCollectCharges
        otherCharges
        signOfShipper
        executedOn
        place
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const getAccount = /* GraphQL */ `
  query GetAccount($id: ID!) {
    getAccount(id: $id) {
      id
      jobId
      partyNameSales1
      invoiceDateSales1
      invoiceNoSales1
      amountSales1
      partyNameSales2
      invoiceDateSales2
      invoiceNoSales2
      amountSales2
      partyNameCha
      invoiceDateCha
      invoiceNoCha
      amountCha
      partyNameTransport
      invoiceDateTransport
      invoiceNoTransport
      amountTransport
      partyNamePurchase1
      invoiceDatePurchase1
      invoiceNoPurchase1
      amountPurchase1
      partyNamePurchase2
      invoiceDatePurchase2
      invoiceNoPurchase2
      amountPurchase2
      partyNameRebate1
      invoiceDateRebate1
      invoiceNoRebate1
      amountRebate1
      partyNameRebate2
      invoiceDateRebate2
      invoiceNoRebate2
      amountRebate2
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listAccounts = /* GraphQL */ `
  query ListAccounts(
    $filter: ModelaccountFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAccounts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        jobId
        partyNameSales1
        invoiceDateSales1
        invoiceNoSales1
        amountSales1
        partyNameSales2
        invoiceDateSales2
        invoiceNoSales2
        amountSales2
        partyNameCha
        invoiceDateCha
        invoiceNoCha
        amountCha
        partyNameTransport
        invoiceDateTransport
        invoiceNoTransport
        amountTransport
        partyNamePurchase1
        invoiceDatePurchase1
        invoiceNoPurchase1
        amountPurchase1
        partyNamePurchase2
        invoiceDatePurchase2
        invoiceNoPurchase2
        amountPurchase2
        partyNameRebate1
        invoiceDateRebate1
        invoiceNoRebate1
        amountRebate1
        partyNameRebate2
        invoiceDateRebate2
        invoiceNoRebate2
        amountRebate2
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const jobCardByDate = /* GraphQL */ `
  query JobCardByDate(
    $type: String
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModeljobCardFilterInput
    $limit: Int
    $nextToken: String
  ) {
    jobCardByDate(
      type: $type
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyName
        jobNo
        impExp
        mode
        airlineName
        masterBLNo
        masterAWBNo
        houseBLNo
        houseAWBNo
        AWBDate
        AWBId
        shipperName
        shipperAddress01
        shipperAddress02
        shipperAddress03
        shipperAddress04
        consigneeName
        consigneeAddress01
        consigneeAddress02
        consigneeAddress03
        consigneeAddress04
        notifyName
        notifyAddress01
        notifyAddress02
        notifyAddress03
        notifyAddress04
        deliveryAgentName
        deliveryAgentAddress01
        deliveryAgentAddress02
        deliveryAgentAddress03
        deliveryAgentAddress04
        placeOfReceipt
        portOfLoading
        EtdAtPortOfLoading
        portOfDischarge
        finalPlaceOfDelivery
        EtaAtPortOfDischarge
        vesselVoy
        bookingAgentName
        bookingAgentAddress
        marksAndNumbers
        containerNo
        lineSealNo
        customSealNo
        typeOfContainer
        description
        netWeight
        grossWeight
        measurement
        chaName
        checkListNo
        checkListDate
        shippingBillNo
        shippingBillDate
        coLoader
        stuffingDate
        noOfPackages
        pallet
        palletNo
        certificate
        otherCertificateName
        insurance
        transportation
        specialInstructions
        editable
        RequestedDate
        accountId
        ownerEmail
        status
        type
        closeAt
        closeBy
        cancelAt
        cancelBy
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const bookingAgentByDate = /* GraphQL */ `
  query BookingAgentByDate(
    $type: String
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelbookingAgentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    bookingAgentByDate(
      type: $type
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        address
        type
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const shipperByDate = /* GraphQL */ `
  query ShipperByDate(
    $type: String
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelshipperFilterInput
    $limit: Int
    $nextToken: String
  ) {
    shipperByDate(
      type: $type
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        address01
        address02
        address03
        address04
        createdAt
        type
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const consigneeByDate = /* GraphQL */ `
  query ConsigneeByDate(
    $type: String
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelconsigneeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    consigneeByDate(
      type: $type
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        address01
        address02
        address03
        address04
        createdAt
        type
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const notifyByDate = /* GraphQL */ `
  query NotifyByDate(
    $type: String
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelnotifyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    notifyByDate(
      type: $type
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        address01
        address02
        address03
        address04
        createdAt
        type
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const deliveryAgentByDate = /* GraphQL */ `
  query DeliveryAgentByDate(
    $type: String
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModeldeliveryAgentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    deliveryAgentByDate(
      type: $type
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        address01
        address02
        address03
        address04
        createdAt
        type
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
